import React from 'react';
import { TranslationHelpers } from '../../../i18n/translationHelpers';
import OverlayDialog from '../../../app/common/components/OverlayDialog';
import DeleteConfirmation from '../DeleteConfirmation';
import { FormManditoryAstrixMessage } from '../../../app/common/components/FormManitoryMessage';
import styled from 'styled-components';

export type DsrDeletionOverlayProps = {
    showDSRForm: boolean;
    closeDSRForm(): void;
    onAccept(password: string): void;
    deleting: boolean;
    challengerPid: string;
};

const MandatoryFieldMessage = styled.div`
    margin: 30px 0px;
    width: 100%;
    display: flex;
`;

const DsrDeletionOverlay: React.FC<DsrDeletionOverlayProps> = (props) => {
    const { showDSRForm, closeDSRForm, onAccept, deleting, challengerPid } = props;

    return (
        <div data-qa-id="dsr-deletion-overlay">
            <OverlayDialog
                title={TranslationHelpers.getMessageDescriptor(
                    'dsr.delete_service_confirmation_heading',
                )}
                isOpen={showDSRForm}
                onClose={closeDSRForm}
            >
                <DeleteConfirmation
                    onAccept={onAccept}
                    onClose={closeDSRForm}
                    deleting={deleting}
                    formattedMessage={
                        <>
                            <MandatoryFieldMessage>
                                <FormManditoryAstrixMessage />
                            </MandatoryFieldMessage>
                            {TranslationHelpers.getFormattedMessage(
                                'dsr.delete_service_confirmation_body_1',
                            )}
                            <br />
                            <br />
                            {TranslationHelpers.getFormattedMessage(
                                'dsr.delete_service_confirmation_body_2',
                            )}
                            <br />
                            <br />
                            {TranslationHelpers.getFormattedMessage(
                                'dsr.delete_service_confirmation_body_3',
                            )}
                            <br />
                            <br />
                            {TranslationHelpers.getFormattedMessage(
                                'dsr.delete_service_confirmation_body_4',
                            )}
                            <br />
                        </>
                    }
                    confirmText={TranslationHelpers.getMessageDescriptor(
                        'dsr.delete_service_confirmation_confirm',
                    )}
                    challengerPid={challengerPid}
                />
            </OverlayDialog>
        </div>
    );
};

export default DsrDeletionOverlay;
